// src/utils/notifications.js

const FUNCTION_URL =
  "https://us-central1-cancionesia.cloudfunctions.net/notifySongReady";

/**
 * Envía notificación a 1 o varios usuarios.
 *
 * @param {Object} params
 * @param {string} params.titulo - Título de la notificación
 * @param {string} params.descripcion - Mensaje / descripción
 * @param {boolean} [params.envioMultiple=false] - Si true, envía a varios
 * @param {string} [params.usuarioId=""] - UID destino (si envioMultiple=false)
 * @param {string[]} [params.multiUsuarios=[]] - UIDs destino (si envioMultiple=true)
 *
 * @returns {Promise<{ok:boolean, sent?:number, failed?:number, raw?:any}>}
 */
export async function enviarNotificacion({
  titulo,
  descripcion,
  envioMultiple = false,
  usuarioId = "",
  multiUsuarios = [],
}) {
  const t = (titulo ?? "").trim();
  const d = (descripcion ?? "").trim();

  if (!t || !d) {
    throw new Error("Falta título o descripción.");
  }

  // Normalizamos destinos
  let uids = [];
  if (envioMultiple) {
    uids = Array.isArray(multiUsuarios)
      ? multiUsuarios.map((x) => String(x || "").trim()).filter(Boolean)
      : [];
  } else {
    const one = String(usuarioId || "").trim();
    if (one) uids = [one];
  }

  if (uids.length === 0) {
    throw new Error("No hay usuarios destino para la notificación.");
  }

  // Si tu Cloud Function solo acepta 1 uid, enviamos 1 por 1
  // (esto funciona hoy con tu endpoint actual)
  let sent = 0;
  let failed = 0;
  const errors = [];

  for (const uid of uids) {
    try {
      const resp = await fetch(FUNCTION_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          uid,
          titulo: t,
          descripcion: d,
        }),
      });

      let json = null;
      try {
        json = await resp.json();
      } catch (_) {
        // ignore
      }

      if (!resp.ok || (json && json.ok === false)) {
        const errText = json?.error || json?.raw || `HTTP ${resp.status}`;
        throw new Error(errText);
      }

      // si el endpoint ya devuelve sent/failed úsalo, si no, cuenta 1
      sent += Number(json?.sent ?? 1);
      failed += Number(json?.failed ?? 0);
    } catch (e) {
      failed += 1;
      errors.push({ uid, error: e?.message || String(e) });
    }
  }

  if (failed > 0) {
    // No forzamos throw si hubo parciales, depende de ti.
    // Yo regreso ok=false con detalle para que lo muestres en UI si quieres.
    return { ok: false, sent, failed, raw: errors };
  }

  return { ok: true, sent, failed };
}
